import React from "react";

import { ThreeDot } from "react-loading-indicators";

import { LoadingModalProps } from "../../types/LoadingModalProps";

const LoadingModal = ({ message }: LoadingModalProps): JSX.Element => {
  return (
    <div className="flex flex-col items-center p-10 gap-y-4 justify-center min-h-screen w-full">
      <div className="max-w-3xl border p-10 rounded-3xl shadow-md bg-white items-center flex flex-col">
        <div className="flex flex-col gap-y-2 justify-center items-center">
          <ThreeDot color="#e0bb84" size="medium" text="" textColor="" />

          <div className="flex flex-col gap-y-1 mt-4 justify-center items-center text-center">
            <span className="text-md sm:text-xl">{message || "กำลังโหลด..."}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;